import React from "react";
const Certifications = () => {
  return (
    <div>
      <h1 className="uppercase text-primary my-5 lg:text-2xl font-bold flex justify-center">
        some of my Certifications{" "}
      </h1>
      <div className="grid lg:grid-cols-2 justify-between items-center h-[100vh] p-10">
        <div className="pb-5">
          <img
            src="https://i.ibb.co/grJQY9K/certificate.jpg"
            alt="Programming hero certificate"
            className="w-100 h-80 mx-auto"
          />
        </div>

     

        <div className=" pb-5">
          <img
            src="https://i.ibb.co/rxLsWDg/wild-Learner.jpg"
            alt="Wild learner certificate"
            className="w-100 h-80 mr-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default Certifications;
